import { action } from 'typesafe-actions';
import {
  AdvertisementTelevisionResult,
  IAdvertisementTelevisionActionTypes,
} from './Types';

export const getAdvertisementTelevision = (id: number) =>
  action(IAdvertisementTelevisionActionTypes.GET_AD_TV, id);
export const getAdvertisementTelevisionSuccess = (
  result: AdvertisementTelevisionResult
) => action(IAdvertisementTelevisionActionTypes.GET_AD_TV_SUCCESS, result);
export const getAdvertisementTelevisionFailure = (err: string) =>
  action(IAdvertisementTelevisionActionTypes.GET_AD_TV_FAILURE, err);
